export const TASK_DATA="TASK_DATA";
export const DASHBOARD="DASHBOARD";
export const FETCH_CURRENT_USER="FETCH_CURRENT_USER";
export const FETCH_AUTH_PRIVILEGE="FETCH_AUTH_PRIVILEGE";
export const FETCH_USERS="FETCH_USERS";
export const FETCH_USER="FETCH_USER";
export const SAVE_USER="SAVE_USER";
export const UPDATE_USER="UPDATE_USER";
export const FETCH_PRIVILEGES="FETCH_PRIVILEGES";
export const FETCH_PRIVILEGE="FETCH_PRIVILEGE";
export const SAVE_PRIVILEGE="SAVE_PRIVILEGE";
export const UPDATE_PRIVILEGE="UPDATE_PRIVILEGE";
export const FETCH_ROLES="FETCH_ROLES";
export const FETCH_ROLE="FETCH_ROLE";
export const SAVE_ROLE="SAVE_ROLE";
export const UPDATE_ROLE="UPDATE_ROLE";
export const FETCH_TASKS="FETCH_TASKS";
export const FETCH_TASK="FETCH_TASK";
export const SAVE_TASK="SAVE_TASK";
export const UPDATE_TASK_ASSIGNEE="UPDATE_TASK_ASSIGNEE";
export const ADD_TASK_COMMENT="ADD_TASK_COMMENT";
export const UPDATE_TASK_FILE="UPDATE_TASK_FILE";
export const UPDATE_TASK_STATUS="UPDATE_TASK_STATUS";